import { Link } from "react-router-dom";
import PreviewImage from "../../../../ExternalLib/PreviewImage/PreviewImage.jsx";
const Project = ({ project, ratio }) => {
  const createSlug = (name, id) => {
    return `${name.toLowerCase().replace(/\s+/g, "-")}-${project?.id}`;
  };
  return (
    <div className="col-12 col-xl-6 col-xxl-6">
      <div className="card border h-100 w-100 overflow-hidden">
        <div className="card-body p-2">
          <div class="row g-0  border-bottom   align-items-end justify-content-between">
            <div class="col-auto">
              <h4 class="flex-1 mb-0 text-nowrap">
                {" "}
                <i class="bi bi-grip-vertical "></i>
                {project?.projectName}
              </h4>
            </div>
            <div class="col-auto">
              <Link
                class="fw-bold fs-9"
                to={`/gallery/${createSlug(project?.projectName)}`}
              >
                View All
              </Link>
            </div>
          </div>
          <div className="row">
            {project?.projectImages?.slice(0, ratio ? 6 : 3).map((imgUrl) => (
              <div className="col-12 col-md-4 col-xxl-4 ">
                <Link title="Click To View">
                  <PreviewImage
                    ratio={ratio}
                    className="rounded w-100"
                    imgwithUrl={imgUrl}
                  />
                </Link>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
export default Project;
